import * as React from 'react';
import {Link} from 'react-router-dom';
import type {ReactableColumnDef} from '@deviceinsight/ng-ui-components';
import {Button, Icon} from '@deviceinsight/ng-ui-basic-components';
import type {Rule} from '../types';
import RuleActiveCheckbox from '../../../components/ruleengine/RuleActiveCheckbox';
import TriggerShowDetailsButton from '../../../components/ruleengine/condition/TriggerShowDetailsButton';
import {ruleHasOptionalSettings} from '../../../components/ruleengine/ruleEditHelpers';
import hasAuthority from '../../../components/common/hasAuthority';
import {AUTHORITY_READ_RULE_OPTIONAL_SETTING} from '../../common/consts';

const columnDefinitions = (
	remove: (rule: Rule) => void,
	updateRule: (rule: Rule) => void,
	showDetails: (rule: Rule) => void,
	canDeleteRule: boolean,
	canUpdateRule: boolean,
	assetGroupId: number,
	filteredName = ''
): Array<ReactableColumnDef<Rule>> => {
	const canSeeRuleOptionalSettings = hasAuthority(AUTHORITY_READ_RULE_OPTIONAL_SETTING);
	// @ts-ignore TO DO
	const baseColumns: Array<ReactableColumnDef<Rule>> = [
		{
			name: 'name',
			label: {
				id: 'ruleengine.edit.rule.name',
				defaultValue: 'Name'
			},
			width: '80%',
			render: (rule: Rule) => {
				if (rule.id) {
					return <Link to={`/assetgroups/${assetGroupId}/ruleengine/${rule.id}`}>{rule.name}</Link>;
				} else {
					return <span>{rule.name}</span>;
				}
			},
			filterable: {
				initialValue: filteredName,
				filterType: 'text',
				filterFn: () => true // Actual server-side filtering will be handled by onFilter
			},
			sortable: true
		},
		{
			name: 'action',
			label: {
				id: 'ruleengine.list.action',
				defaultValue: 'Action'
			},
			width: '10%',
			render: (rule: Rule) => {
				const hasOptionalSettings = ruleHasOptionalSettings(rule);

				if (!hasOptionalSettings) {
					return null;
				}

				return <TriggerShowDetailsButton onClick={() => showDetails(rule)} />;
			}
		},
		{
			name: 'active',
			label: {
				id: 'ruleengine.list.active',
				defaultValue: 'Active'
			},
			width: '10%',
			align: 'center',
			render: (rule: Rule) => <RuleActiveCheckbox rule={rule} onChange={updateRule} disabled={!canUpdateRule} />
		}
	].filter((cd) => !(cd.name === 'action' && !canSeeRuleOptionalSettings));
	const deleteColumn: ReactableColumnDef<Rule> = {
		name: 'remove',
		label: {
			id: 'ruleengine.list.remove',
			defaultValue: 'Delete'
		},
		width: '10%',
		align: 'center',
		render: (rule: Rule) => (
			<Button onClick={() => remove(rule)} naked>
				<Icon del />
			</Button>
		)
	};

	if (canDeleteRule) {
		return [...baseColumns, deleteColumn];
	} else {
		return baseColumns;
	}
};

export default columnDefinitions;
